<script>

    import { replace } from 'svelte-spa-router'
    import { adminStore } from '../stores'
    import { isPermission } from '../$methods/permissions.methods'

    import View from '../$layouts/view.layout.svelte'
    import PageHeader from '../$components/page.header.svelte'
    import ModalContainer from '../$components/modal.container.svelte'

    import ShopifyAppsComponent from './component.shopifys.svelte'
    import ShopifyAppsCreateComponent from './component.create.svelte'
    import ShopifyAppsUpdateComponent from './component.update.svelte'

    if(!isPermission($adminStore, 'TracingsView.Shopify.View'))
        replace('/404')

</script>

<View>
    <PageHeader title="Shopify" subtitle="Integraciones con tiendas Shopify" />
    <ShopifyAppsComponent />
</View>

<ModalContainer id="shopify_create_modal" title="Crear aplicacion de shopify" >
    <ShopifyAppsCreateComponent />
</ModalContainer>

<ModalContainer id="shopify_update_modal" title="Actualizar aplicacion de shopify" >
    <ShopifyAppsUpdateComponent />
</ModalContainer>
